import React from 'react';

import styled from 'styled-components';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';

const Style = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  padding-top: 40px;
  padding-bottom: 40px;
  flex-wrap: wrap;
  height: 548px;

  .section {
    display: flex;
    width: 40%;
    max-width: 400px;
    min-width: 240px;
    flex-direction: column;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 70%;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .main-section {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 300px;

    h1 {
      color: #595959;
      font-size: 30px;
      font-weight: 600;
    }

    p {
      color: #595959;
      font-size: 20px;
      font-weight: 400;
    }

    &.centered {
      justify-content: center;
    }
  }

  .btn-icon {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    max-width: 170px;
  }

  .btn-group {
    display: flex;
    flex-direction: column;
    gap: 10px; 
    margin-left: 0px !important;

    button {
      min-width: 200px;
    }
  }

  &.buttonMinWidth250 {
    .btn-group button {
      min-width: 250px;  
    }
  }
`;

const EmptyState = ({
  children,
  imageUrl = '',
  mainSectionCentered = false,
  buttonMinWidth250 = false,
}) => (
  <Style className={buttonMinWidth250 && 'buttonMinWidth250'}>
    <div className="section">
      <img alt="Empty State" src={imageUrl} />
    </div>
    <div className={formatClassname([
      'main-section',
      mainSectionCentered && 'centered',
    ])}>
      {children}
    </div>
  </Style>
);

export default EmptyState;
